
export default function ProblemSection() {
  const stats = [
    {
      icon: 'ri-global-line',
      number: '280M',
      label: 'Personas con trastornos de ansiedad según la OMS',
      description: 'Una crisis mundial que afecta la calidad de vida'
    },
    {
      icon: 'ri-time-line',
      number: '73%',
      label: 'Reporta estrés diario según estudios globales',
      description: 'La mayoría vive en constante presión'
    },
    {
      icon: 'ri-mind-map',
      number: '65%',
      label: 'Siente desconexión con su propósito de vida',
      description: 'Perdidos en la rutina sin dirección clara y en confusión mental'
    }
  ];

  const problems = [
    {
      icon: 'ri-book-open-line',
      title: 'Exceso de información',
      description: 'Consumes contenido sobre bienestar pero no sabes cómo aplicarlo de manera práctica y sostenible.',
      color: 'from-red-100 to-pink-100',
      iconColor: 'text-red-600'
    },
    {
      icon: 'ri-calendar-close-line',
      title: 'Falta de constancia',
      description: 'Empiezas programas y rutinas con entusiasmo, pero los abandonas al cabo de pocos días por falta de estructura.',
      color: 'from-orange-100 to-yellow-100',
      iconColor: 'text-orange-600'
    },
    {
      icon: 'ri-user-line',
      title: 'Soledad en el proceso',
      description: 'Intentas cambiar solo, sin apoyo ni comunidad que te acompañe y te mantenga motivado en el camino.',
      color: 'from-blue-100 to-indigo-100',
      iconColor: 'text-blue-600'
    }
  ];

  return (
    <section id="problema" className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-8">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 tracking-tight">
            El problema es
            <span className="block font-thin bg-gradient-to-r from-gray-600 to-gray-800 bg-clip-text text-transparent">
              más profundo
            </span>
          </h2>
          <p className="text-2xl text-gray-600 leading-relaxed font-light">
            La Organización Mundial de la Salud confirma lo que ya intuyes: vivimos una crisis global de bienestar mental.
          </p>
        </div>

        {/* Global Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-3xl p-10 shadow-sm border border-gray-100 text-center hover:shadow-lg transition-all duration-500 transform hover:-translate-y-1">
              <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className={`${stat.icon} text-3xl text-gray-600`}></i>
              </div>
              <div className="text-5xl font-light text-[#6607a5] mb-3">{stat.number}</div>
              <h3 className="text-xl font-medium text-gray-900 mb-3 leading-tight">{stat.label}</h3>
              <p className="text-gray-600 font-light leading-relaxed">{stat.description}</p>
            </div>
          ))}
        </div>

        {/* Problem Areas */}
        <div className="max-w-6xl mx-auto">
          <h3 className="text-4xl font-light text-center text-gray-900 mb-16">Tres barreras que impiden tu cambio real</h3>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {problems.map((problem, index) => (
              <div key={index} className="group">
                <div className="bg-white rounded-3xl p-10 shadow-sm border border-gray-100 h-full hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className={`w-20 h-20 bg-gradient-to-br ${problem.color} rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${problem.icon} text-3xl ${problem.iconColor}`}></i>
                  </div>
                  <h4 className="text-2xl font-medium text-gray-900 mb-6">{problem.title}</h4>
                  <p className="text-gray-600 leading-relaxed font-light text-lg">{problem.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-20">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-12 text-white max-w-4xl mx-auto">
            <h4 className="text-3xl font-light mb-6">¿Te identificas con esto?</h4>
            <p className="text-xl text-gray-300 mb-8 font-light leading-relaxed">
              No estás solo. Miles de personas sienten exactamente lo mismo. 
              Es hora de un enfoque diferente.
            </p>
            <div className="w-16 h-1 bg-gradient-to-r from-[#6607a5] to-purple-400 mx-auto rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
